module.exports = __webpack_public_path__ + "images/aller-national-logo-black_54f13b62ba73fe69f843ca475c064971.svg";